import React, { useContext, useLayoutEffect, useRef } from 'react';
import { LOGOUT } from '../../../../../util/universalConstans';
import { setL } from '../../../../../util/lib';
import HybridLink from '../../../hybrid/footer/HybridLink';
import HeaderLogout from './HeaderLogout';
import { RATIO_1x1 } from '../../../../../util/imageUtils';

import './scss/HeaderDropDownMenu.scss';
// import { HeaderContext } from '../../HeaderContext';
import Close from '../../../../svg/IconV2-2/Close';
import { COLLAPSE_ALL } from '../constants';
import { SideMenuContext } from '../../../sideMenu/SideMenuManager';

const BORDER_BOTTOM = 'border-bottom',
	HeaderDropDownMenu = ({ additionalClass = '', data: wData = {}, id = '', title = '', faIconClass = '', meta = {}, mobileDisplayNav = COLLAPSE_ALL }) => {
		const { label = '', cards = [], thumbnails = '' } = wData,
			thumbnail1x1 = thumbnails[RATIO_1x1] || {},
			thumbnail = thumbnail1x1['150'] || thumbnail1x1['320'] || thumbnail1x1['450'] || '',
			{ label: labelMeta = {}, thumbnail: thumbnailMeta = {} } = meta,
			// { widget = {} } = useContext(HeaderContext);
			{ sideMenuData = {} } = useContext(SideMenuContext),
			{ setOpenState: setSideMenuOpenState = '' } = sideMenuData,
			dropdownMenuRef = useRef(null),
			menuHeadRef = useRef(null);

		useLayoutEffect(() => {
			const menuHead = menuHeadRef.current;
			
			if (menuHead) {
				const onClick = () => { 
					setSideMenuOpenState(false);
				};
				menuHead.addEventListener('click', onClick);
				
				return () => { 
					menuHead.removeEventListener('click', onClick);
				};
			}
		}, [menuHeadRef]);

		return (<span className={`header-dropdown-menu ${mobileDisplayNav === COLLAPSE_ALL ? ' collapse-all': ''}`}>
			{thumbnail && thumbnailMeta.canShow ? <a href='/'
				className="dropdown-img dropdown-link"
				data-toggle='dropdown'
				role='button'
				aria-haspopup='true'
				ref={menuHeadRef}
				id={id}
				aria-expanded='false'
			>
				<div className="thumbnail-box">
					<img src={thumbnail} alt ="thumbnail-box"></img>
				</div> 
				<div className='label'>
					{labelMeta.canShow && label}
				</div>
			</a> : <a href='/' className={additionalClass}
				data-toggle='dropdown'
				role='button'
				aria-haspopup='true'
				id={id}
				aria-expanded='false'
			>
				<span className='dropdown-toggle'>
					{labelMeta.canShow && label}
					{faIconClass && <i className={faIconClass} aria-hidden="true"></i>}
				</span>
			</a>}
			<div ref={dropdownMenuRef} className='dropdown-menu sub-link' aria-labelledby={id}>
				{thumbnail && thumbnailMeta.canShow ? <span className="dropdown-item close">
					<div className='close-box'>
						<Close />
					</div>
				</span> : <>
					{title && <span className={`dropdown-item title ${BORDER_BOTTOM}`}>
						{title}
					</span>}
				</>}

				{cards.map((card, index) => {
					const { data: cardData = {}, meta: metaMeta = {} } = card,
						{ action = {}, label = '' } = cardData,
						{ action_intent = {} } = action,
						borderBottomClass = metaMeta['border-bottom'] ? ' ' + BORDER_BOTTOM : '';

					return (<React.Fragment key={`hddm-sm-${index}`}>
						{(action_intent.name === LOGOUT || label === 'Logout') ? <HeaderLogout 
							label={label}
							onClick={() => { setL('lastVideoLocation', '') }}
							cssClass={`true-link dropdown-item${borderBottomClass}`} 
						/> : <HybridLink 
							data={card}
							onClick={(evt = '') => { 
								setL('lastVideoLocation', '') ;
							}}
							labelAdditionalClass={`dropdown-item${borderBottomClass}`} 
						/>}
					</React.Fragment>);
				})}
			</div>
		</span>
		);
	};

export default HeaderDropDownMenu;